import React from "react";
import { CircularProgress } from "@mui/material";

function LoadingProgress({ size = 40 }) {
  return (
    <div className="w-full h-full flex items-center justify-center">
      <CircularProgress size={size} />
    </div>
  );
}

export default LoadingProgress;
